import React from 'react'
import dynamic from 'next/dynamic'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { FullScreenLoading } from 'src/components/full-screen-loading'
import { DriveTimeIcon } from 'src/components/insights/icons/drive-time'
import { INSIGHTS_TIER } from 'src/constants/insights-tier'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'
import { Colors } from 'src/components/theme'

const DriveTimeTradeAreaContent = dynamic(() => import('src/components/insights/drive-time-trade-area/content'), {
  loading: () => <FullScreenLoading />,
  ssr: false,
})

const DriveTimeTradeAreaPage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props
  return (
    <InsightContainer insight={insight} color={Colors.blueDark}>
      <React.Suspense fallback={<FullScreenLoading />}>
        <DriveTimeTradeAreaContent insight={insight} />
      </React.Suspense>
    </InsightContainer>
  )
}

export const DriveTimeTradeArea: Insight = {
  id: 'drive-time-trade-area',
  component: DriveTimeTradeAreaPage,
  name: 'Drive Time Trade Area',
  icon: DriveTimeIcon,
  supportedResultTypes: ['venue', 'address', 'alphamap-location'],
  linkTooltipFile: 'insights-link-drive-time-trade-area',
  tier: INSIGHTS_TIER['Drive Time Trade Area'],
}
